import { getThemeComponent } from './index';

export default getThemeComponent('ThemeBackground');
